import classNames from "classnames";
import { Subscribe } from "unstated";

import miniNavigationStyles from "./MiniNavigation.css";

import { withViewport } from "/react/utils/withViewport";

import { MiniNavigationContainer, ContentBoxTitle } from "/react/library";

@withViewport()
export class MiniNavigation extends React.PureComponent {
  handleOnClick = (miniNavigation, index) => {
    window.location.hash = miniNavigation.sectionTitles[index];
  };

  render() {
    const { viewportIsDesktopOrBigger } = this.props;

    return (
      <div>
        {viewportIsDesktopOrBigger && (
          <Subscribe to={[MiniNavigationContainer]}>
            {(miniNavigation) => (
              <div
                className={classNames(miniNavigationStyles.container, {
                  [miniNavigationStyles.isLight]:
                    miniNavigation.state.color === "light",
                  [miniNavigationStyles.isGone]:
                    miniNavigation.state.color === "hide",
                  [miniNavigationStyles.isHiding]:
                    miniNavigation.state.isHiding,
                })}
              >
                <ul className={miniNavigationStyles.sections}>
                  {miniNavigation.sectionTitles.map((sectionTitle, index) => {
                    return (
                      <li
                        key={index}
                        className={classNames(miniNavigationStyles.section, {
                          [miniNavigationStyles.sectionIsActive]:
                            miniNavigation.state.activeIndex === index,
                          [miniNavigationStyles.sectionIsExpanded]:
                            miniNavigation.state.activeIndex === index &&
                            miniNavigation.state.isExpanded,
                        })}
                      >
                        <div
                          className={miniNavigationStyles.dot}
                          onClick={() =>
                            this.handleOnClick(miniNavigation, index)
                          }
                        />

                        <div
                          className={miniNavigationStyles.animationContainer}
                        >
                          <span
                            className={miniNavigationStyles.sectionTitle}
                            onClick={() =>
                              this.handleOnClick(miniNavigation, index)
                            }
                          >
                            <ContentBoxTitle>{sectionTitle}</ContentBoxTitle>
                          </span>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </Subscribe>
        )}
      </div>
    );
  }
}
